import { Link } from "react-router-dom";
import "./DetalleLayout.scss";
import { IoChevronBack } from "react-icons/io5";
import Button from "../../components/common/Button/Button";

export default function DetalleLayout({
    title,
    backLink,
    backText = "Volver",
    loading = false,
    error = null,
    notFound = false,
    children,
    className = "",
    headerActions = null,
}) {
    if (loading) {
        return (
            <div className={`detalle-layout ${className}`}>
                <div className="detalle-layout__loading">
                    <div className="spinner"></div>
                    <p>Cargando información...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`detalle-layout ${className}`}>
                <div className="detalle-layout__error">
                    <h2>Error al cargar</h2>
                    <p>{error}</p>
                    {backLink && (
                        <Link to={backLink}>
                            <Button variant="filled">{backText}</Button>
                        </Link>
                    )}
                </div>
            </div>
        );
    }

    if (notFound) {
        return (
            <div className={`detalle-layout ${className}`}>
                <div className="detalle-layout__not-found">
                    <h2>No encontrado</h2>
                    <p>El elemento solicitado no existe.</p>
                    {backLink && (
                        <Link to={backLink}>
                            <Button variant="filled">{backText}</Button>
                        </Link>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className={`detalle-layout ${className}`}>
            <div className="detalle-layout__header">
                {backLink && (
                    <Link to={backLink} className="detalle-layout__back-link">
                        <IoChevronBack size={18} />
                        {backText}
                    </Link>
                )}
                <h1 className="detalle-layout__title">{title}</h1>
                {headerActions && (
                    <div className="detalle-layout__actions">
                        {headerActions}
                    </div>
                )}
            </div>
            {children}
        </div>
    );
}
